import React from 'react';
import { TESTS, TestKey } from '../data/tests';

interface TestBadgeProps {
  test: TestKey;
  /** Trailing detail after the name, e.g. the child's name or the grade. */
  subject?: string;
  /** `lg` is for the loading / error screens, where the badge stands alone. */
  size?: 'sm' | 'lg';
  className?: string;
}

/**
 * The journey card's artwork and name, repeated inside the test itself, so a
 * child who tapped "Read Aloud" sees "Read Aloud" on the screen that follows.
 */
export const TestBadge: React.FC<TestBadgeProps> = ({ test, subject, size = 'sm', className }) => {
  const identity = TESTS[test];
  const large = size === 'lg';

  return (
    <div className={`flex items-center gap-2 ${large ? 'justify-center' : 'justify-end'} ${className || ''}`}>
      <span className={`flex-shrink-0 ${large ? 'w-12 h-12' : 'w-8 h-8'}`}>
        <img
          src={identity.logo}
          alt=""
          className="w-full h-full object-contain"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            const fallback = e.currentTarget.nextElementSibling as HTMLElement | null;
            if (fallback) fallback.style.display = 'inline';
          }}
        />
        <span style={{ display: 'none' }} aria-hidden="true">
          {identity.icon}
        </span>
      </span>
      <span className={`font-bold text-[#8E7BFF] ${large ? 'text-2xl' : 'text-sm'}`}>
        {identity.title}
        {subject ? ` - ${subject}` : ''}
      </span>
    </div>
  );
};

export default TestBadge;
